import { createAxiosClient } from './create.axios.client'

const baseDomain = process.env.VUE_APP_API_VENTURES_URL

const clientVentures = createAxiosClient({
	baseURL: baseDomain,
	headers: {
		'Content-Type': 'application/json',
		Accept: 'application/json',
		'Content-Language': `pt-BR`,
	},
})

clientVentures.interceptors.request.use(
	config => {
		const token = typeof window !== 'undefined' ? sessionStorage.getItem('token') : null
		if (token) {
			config.headers.common.Authorization = token
		}
		return config
	},
	function (error) {
		return Promise.reject(error)
	},
)

clientVentures.interceptors.response.use(
	res => {
		if (res.status === 401) {
			//todo log out the user
		}
		const hasAuthProperty = Object.prototype.hasOwnProperty.call(res.data, 'token')
		if (hasAuthProperty) {
			if (typeof window !== 'undefined') {
				sessionStorage.setItem('token', 'bearer ' + res.data.token)
			}
		}
		return res
	},
	function (error) {
		return Promise.reject(error)
	},
)

export default clientVentures
